import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";

import { Link } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import { formatNumber } from "@/features/shared";

// Rendered inside the detail page's tab panel, which already names it — no
// heading of its own.
export const DownPaymentAllocationsSection = ({
  salesDownPaymentAllocations,
}) => {
  const columns = [
    {
      field: "referenceNumber",
      headerName: "No. Faktur",
      flex: 2,
      valueGetter: (_, row) =>
        row.sourceReferenceNumber ?? row.sourceSalesInvoice?.referenceNumber,
      renderCell: ({ value }) =>
        value ? (
          <Link
            component={RouterLink}
            to={`/sales/sales-down-payments/${value}`}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
          >
            {value}
          </Link>
        ) : (
          "-"
        ),
    },
    {
      field: "amount",
      headerName: "Nominal",
      flex: 1,
      type: "number",
      valueFormatter: (value) => formatNumber(value || 0),
    },
    {
      field: "note",
      headerName: "Catatan",
      flex: 2,
      valueGetter: (_, row) =>
        row.note ?? row.sourceSalesInvoice?.note ?? "-",
    },
  ];

  return (
    <DataGrid
      columns={columns}
      rows={salesDownPaymentAllocations || []}
      disableRowSelectionOnClick
      hideFooter
    />
  );
};

DownPaymentAllocationsSection.propTypes = {
  salesDownPaymentAllocations: PropTypes.array,
};
